import { GetMentorFormServices } from "./service";
import { toast } from "react-toastify";
import { GET_A_MENTOR_FORM } from "../../common/constants/actionConstants";

import { isLoading } from "../../common/dependencies/action/action";
import swal from "sweetalert";
export const getMentorForms = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindMentorFormData(params).then((data) => {
    const { mentorFormList } = data;
    //
    if (mentorFormList) {
      dispatch({
        type: GET_A_MENTOR_FORM,
        payload: mentorFormList,
      });
    }
    dispatch(isLoading(false));
  });
};
export const registerCohort = (params, Status) => async (dispatch) => {
  //
  dispatch(isLoading(true));
  return GetMentorFormServices.registerCohort(params)
    .then((response) => {
      //
      dispatch(isLoading(false));

      if (response?.data?.success) {
        dispatch(isLoading(false));
        // window.location.href = "/";
        // setTimeout(() => {
        //   window.location.href = "/";
        // }, 3500);
        if (Status === "VERIFIED") {
          swal(
            "Thank you",
            " Cohort Application Updated Successfully.",
            "success",
            { closeOnClickOutside: false }
          );
        } else {
          swal(
            "Thank you",
            " Cohort Application Submitted Successfully.",
            "success",
            {
              closeOnClickOutside: false,
              buttons: {
                redirect: {
                  text: "OK",
                },
              },
            }
          ).then((value) => {
            switch (value) {
              case "redirect":
                window.location.reload();

                break;
              default:
            }
          });
        }
        // toast.success(response?.data?.data);
        return true;
      } else {
        dispatch(isLoading(false));
        swal("Try Again", response?.data?.errors[0].message, "error", {
          closeOnClickOutside: false,
        });

        return false;
      }
    })
    .catch((error) => {
      swal("Try Again", "Currently Service is Unavailable", "error", {
        closeOnClickOutside: false,
      });
      dispatch(isLoading(false));
    });
};
export const savedraftCohort = (params, buttontype) => async (dispatch) => {
  //

  if (buttontype === "savedraftbutton") {
    dispatch(isLoading(true));
  }
  // dispatch(isLoading(true));
  return GetMentorFormServices.savedraftCohort(params)
    .then((response) => {
      //
      if (response?.data?.success) {
        dispatch(isLoading(false));

        if (buttontype === "savedraftbutton") {
          dispatch(isLoading(false));

          swal(
            "Thank you",
            " Draft Saved Successfully, Please Complete Your Application To Submit.",

            { closeOnClickOutside: false }
          );
        }

        // swal(
        //   "Thank you",
        //   " Draft saved Successfully.",
        //   // " To View Your Application Status, Log In again.",
        //   // "success",
        //   { closeOnClickOutside: false }
        // );
        return true;
      } else {
        dispatch(isLoading(false));
        // window.location.href = "/";
        // toast.error(response?.data?.errors[0]?.message);
        // swal("Retry", "Please Try Again", "error", {
        //   closeOnClickOutside: false,
        // });
        return false;
      }
    })
    .catch((error) => {
      // toast.error(INTERNAL_SERVER_ERROR);
      dispatch(isLoading(false));
    });
};
async function getBindMentorFormData() {
  const mentorFormList =
    await GetMentorFormServices.getMentorFormServices().catch((e) => {
      return { data: [], status: false };
    });

  return { mentorFormList };
}
